import { Component, createRef } from 'react';
import { Row, Form, Col, Button } from 'react-bootstrap';
import moment from 'moment';
import * as momentTz from 'moment-timezone';
import axios from 'axios';
import DatePicker from "react-datepicker";
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { ArrayValueReorder } from 'shared/modifiers';
import { locationlist, statelist, citylist,taxexemptionpending } from 'shared/settings/apiconfig';
import Datatable from 'shared/datatable';

import './LocationList.scss';

export class LocationTaxExemption extends Component {

    config;
    initialSearchState;

    constructor(props) {
        super(props);

        this.dataTable = createRef();

        /* initial search state */
        this.initialSearchState = {
            locationid: { field: 'locationid', value: "", op: '=', join: 'AND' },
            starttime: { field: 'fromdate', value: '', op: '>=', join: 'AND' },
            endtime: { field: 'todate', value: '', op: '<=', join: 'AND' },
        }

        this.state = {
            search: this.initialSearchState,
            searchData: false,
            tableData: [],
            issearch: false,
            stateList: [],
            locationList: [],
            cityList: []
        }
        this.config = {
            url: taxexemptionpending,
            params: {},
            buyerUrl: {},
            ignoreRowBackground: true,
            columns: [
                { name: 'Name', property: 'firstname', sort: true, width: '150px',columnType: 'custom', customColumn: this.customName },
                { name: 'Nick Name', property: 'lastname', sort: true, width: '150px' },
                { name: 'Email', property: 'email', sort: true, width: '230px' },
                { name: 'Phone', property: 'mobile', sort: true, width: '150px' },
                { name: 'Status', property: 'active', sort: true, width: '120px',columnType: 'custom', customColumn: this.customStatus  },
                { name: 'Tax Exemption Submission Date', property: 'taxsubmissiondate', sort: true, width: '150px', columnType: 'custom', customColumn: this.taxExemptdate },
      
            ],
            sort: [{field: "taxsubmissiondate", direction: "desc"}],
            pagination: true,
            field:["id","firstname","lastname","email","locationid","nickname","mobile","active","modifieddate","purchasedate","city","address1","address2","state","zipcode","taxsubmissiondate"],       
            defaultFilter: [{field: "isDeleted", value: 0, op: "=", join: "AND"},
            {field: "active", value: 1, op: "=", join: "AND"},{field: "shipping", value: 1, op: "=", join: "AND"}],
           
        };
        this.search = {};
        this.startDatePicker = false;
        this.endDatePicker = false;
        this.id = null;
        this.sales = [];
        this.filterSearch = {};
        this.locations = [];
    }

 

    // handle enter key search
    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.enableSearch()
        }
    }
    getLocationList = async () => {
        await axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders())
            .then(response => {
                this.setState({
                    locationList: ArrayValueReorder([...response.data['data']], 'title')
                })
            })
            .catch(error => {
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            });
    };

    customStatus = (values) => {
        if (values['active'])
            return <span>Active</span>;
        else
            return <span>Inactive</span>;
    }

    taxExemptdate = (value) => {
        if (value['taxsubmissiondate']) {
            return `${moment.utc(value['taxsubmissiondate']).local().format('MM/DD/YYYY')}`;
        }
        return '- - -';
    };

    customName = (values) => <span>{`${values['lastname']} ${values['firstname']}`}</span>;
    
    customDate = (value) => {
        if (value['modifieddate']) {
            return `${moment.utc(value['modifieddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    };

    componentDidMount() {
        this.getStateList();
        this.getLocationList();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack); 
    }

    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }

    /* Get state list */
    getStateList = () => {
        axios.get(getSellerUrl(statelist), getSellerHeaders())
            .then(response => {
                this.stateList = ArrayValueReorder(response.data.data, 'state');
                this.setState({ stateList: this.stateList });
            })
            .catch(error => {
            });
    }

    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value;
     
   
            this.setState({
                ...this.state,
                issearch: true,
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: eventValue
                    }
                }
            }, () => {
           
            });
        
    }

    setDate = (control, date) => {
        const { search } = this.state;
        let errorMessage = '';
    
        // always update in state
        const updatedSearch = {
            ...search,
            [control]: {
                ...search[control],
                value: date
            }
        };
    
        // validate only when both dates exist
        if (updatedSearch.starttime.value && updatedSearch.endtime.value) {
            const start = new Date(updatedSearch.starttime.value);
            const end = new Date(updatedSearch.endtime.value);
    
            const monthsDiff =
                (end.getFullYear() - start.getFullYear()) * 12 +
                (end.getMonth() - start.getMonth());

            if (end < start) {
                errorMessage = "Please select a date range within any 12 month period";
                updatedSearch.endtime.value = null;
            }
            else if (monthsDiff > 12 || (monthsDiff === 12 && end.getDate() > start.getDate())) {
                errorMessage = "Please select a date range within any 12 month period";
            }
        }
    
        this.setState({
            issearch: true,
            errorMessage,
            search: updatedSearch
        });

    }

    /* called when clear all in search clicked */
    resetState = () => {
        let issearchData = this.state.searchData;
        this.setState({
            ...this.state,
            errorMessage: '',
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
        }, () => {
            if (issearchData)
                this.dataTable.current.searchData();
        });
    }

    /* called when search button clicked */
    enableSearch = () => {
        let search = {};
        search = {
            locationid: { ...this.state.search.locationid, value: this.state.search.locationid.value ? [this.state.search.locationid.value] : '' },
            starttime: { ...this.state.search.starttime, value: this.state.search.starttime.value ? moment(new Date(this.state.search.starttime.value)).startOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            endtime: { ...this.state.search.endtime, value: this.state.search.endtime.value ? moment(new Date(this.state.search.endtime.value)).endOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            
            
        }
        this.setState({
            filterSearch: search,
            searchData: true,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* check enable search and clear all */
    checkSearch = () => {
        let isenable = false;
        let issearchData = this.state.searchData;
        for (let control of Object.keys(this.state.search)) {
            if (this.state.search[control].value) {
                isenable = true;
                break;
            }
        }
        this.setState({
            ...this.state,
            search: isenable ? this.state.search : this.initialSearchState,
            searchData: isenable ? this.state.searchData : false,
            issearch: isenable
        }, () => {
            if (!isenable && issearchData)
                this.dataTable.current.searchData();
        });
    }

    /* get city list */
    getCity = () => {
        let cityList = [];
        if (this.state.search.state.value) {
            axios.get(getSellerUrl(`${citylist}/${this.state.search.state.value}`), getSellerHeaders())
                .then(response => {
                    cityList = ArrayValueReorder(response.data.data, 'city');
                    cityList = cityList.filter((city, index) => {
                        const _city = JSON.stringify(city);
                        return index === cityList.findIndex(obj => {
                            return JSON.stringify(obj) === _city;
                        });
                    });
                    this.setState({
                        cityList: cityList,
                        search: {
                            ...this.state.search,
                            city: {
                                ...this.state.search.city,
                                value: ''
                            }
                        }
                    });
                })
                .catch(error => {
                });
        }
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }
    


    render() {

        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }}>
                <div className="sale-search" style={{ backgroundColor:'#BBC7D6' }}>
                    <div className="sales-list-search">
                        <Form className="sales-list-font">
                            <div className="sales-search-container">
                                <Row>
                                    <Col>
                                        <label>Location *</label>
                                        <Form.Control as="select" name="locationid" value={this.state.search.locationid.value} style={{ textTransform: "capitalize" }} onChange={(event) => this.searchInputChange(event)}>
                                        <option value="">Select Location</option>
                                            {
                                                this.state.locationList.map((location, idx) => <option key={idx} value={location['id']}>{location['title']}</option>)
                                            }
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                    <label>Starting Before</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.start.state.open && e.preventDefault()}>
                                                <DatePicker style={{ width: "100%" }} ref={r => this.start = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.starttime.value} selected={this.state.search.starttime.value} onChange={date => { this.setDate('starttime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "55%", right: "25px", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                    <Col >
                                        <label>Starting After</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.end.state.open && e.preventDefault()}>
                                                <DatePicker minDate={this.state.search.starttime.value ? this.state.search.starttime.value : ''} ref={r => this.end = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.endtime.value} selected={this.state.search.endtime.value} onChange={date => { this.setDate('endtime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "55%", right: "25px", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                       
                                </Row>
                            <Row className="d-flex" style={{ marginBottom: "-1%" }}>
                                <Col>
                                </Col>
                                <Col className="d-flex justify-content-center align-items-center">
                                        {this.state.errorMessage && (
                                            <div className="text-danger"  style={{fontSize: '14px'}}>
                                                {this.state.errorMessage}
                                            </div>
                                        )}
                                    </Col>
                                <Col>
                                    <div className="buttonClass">
                                        <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                        <Button variant="seller-search" disabled={!this.state.search.locationid.value || this.state.errorMessage} onClick={() => this.enableSearch()}>Search</Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Form>
                </div>
                
            </div>
            <div className="location-list">
            {/* need to add props, as it provides the previous state of datatable */}
            <Datatable {...this.props} config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable} onDataUpdate={this.updateTableData}></Datatable>
        </div>
        </div>
        );
    }
}